<div class="flex flex-col border-b border-b-gray-100 py-3 px-6">
  <label class="text-xs font-medium text-gray-900">{{ label }}</label>
  <span class="text-gray-500 text-sm"><ng-content></ng-content></span>
</div>
